import { Component, OnInit } from "@angular/core";
import { blogDetails } from "src/app/models/blog.model";
import { BlogService } from "src/services/blog.service";

@Component({
  selector: "app-blog-page",
  templateUrl: "./blog-page.component.html",
  styleUrls: ["./blog-page.component.css"],
})
export class BlogPageComponent implements OnInit {
  blogs: blogDetails[] = [];

  constructor(private blogService: BlogService) {}

  ngOnInit() {
    this.blogService.getAllBlogs().subscribe((res) => {
      // console.log((res as any).blogs);
      this.blogs = (res as any).blogs;
    });
  }
}
